import { defineFeatures } from "../define-provider-capability";

/**
 * The `rudderstack` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const rudderstackMobileFeatures = defineFeatures({
  // Mobile-side RudderStack analytics. Production-only: preview + local
  // mobile builds disable the SDK so analytics don't get polluted with
  // dev/PR data. Gated at runtime via capabilities.allowed("rudderstack").
  mobile: {
    scope: "runtime",
    environments: {
      local: {
        mode: "not-applicable",
        note: "Local mobile builds disable RudderStack.",
      },
      preview: {
        mode: "not-applicable",
        note: "Preview mobile builds disable RudderStack.",
      },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_RUDDERSTACK_WRITE_KEY",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "EXPO_PUBLIC_RUDDERSTACK_DATA_PLANE_URL",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
    ],
  },
});
